import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { useForm } from 'react-hook-form';
import { connect } from 'react-redux';
import { postAPI } from 'store/apiReducer';
import {
    ButtonGroup,
    Button,
    CheckboxControl,
    Row,
    Col,
    SegmentLoader,
} from '@si-armes/dsfr-react';
import {
    FEATURE_CAPTCH_ETAT,
    FEATURE_CAPTCHA,
    isFeatureActive,
} from 'components/FeatureFlipping/featureFlipping.func';
import usagerClientReducer from 'store/usagerReducer';
import {
    API_COMPTE_CREER_ETAPE_VALIDATION_URL,
    CONTEXT_CREER_COMPTE_ETAPE_VALIDATION,
} from 'constants/apiUrls.constants';
import Captcha from 'components/captcha/Captcha';
import ModaleCgu from './ModaleCgu';
import CaptchaEtat from './CaptchaEtat';
import InfoChampsObligatoire from '../../../../../../components/form/infoObligatoire/InfoChampsObligatoire';

const CreerCompteEtapeValidation = ({
    postApi,
    isLoading,
    erreur,
    message,
    data,
    uuidBrouillon,
    setEtapeValidation,
    retourEtape,
    dataValidationRenseignee,
    featureFlipping,
}) => {
    const { register, watch, handleSubmit, formState, getValues } = useForm({
        mode: 'onChange',
        defaultValues: dataValidationRenseignee,
    });

    const { isValid } = formState;
    const [informationsCaptcha, setInformationsCaptcha] = useState();
    const [captchaRecharge, setCaptchaRecharge] = useState(false);
    const [modaleCguOuverte, setModaleCguOuverte] = useState(false);

    useEffect(() => {
        window.scrollTo(0, 0);
    });

    useEffect(() => {
        if (isLoading === false && data && !erreur) {
            setEtapeValidation();
        }
    }, [isLoading, data, erreur]);

    const setInfosCaptcha = (infos) => {
        if (infos) {
            setInformationsCaptcha({
                code: infos.code,
                id: document.getElementsByName('mi-captcha-id')[0].value,
            });
        }
    };

    const setInfoCaptchaEtat = (infos) => {
        if (infos.code) {
            setInformationsCaptcha({
                ...informationsCaptcha,
                code: infos.code,
                captchaEtat: true,
            });
        }
        if (infos.id) {
            setInformationsCaptcha({
                ...informationsCaptcha,
                id: infos.id,
                captchaEtat: true,
            });
        }
    };

    const onSubmit = async (dataForm) => {
        if (
            dataForm &&
            dataForm.declarationHonneur &&
            dataForm.isCguLues &&
            uuidBrouillon &&
            (informationsCaptcha || !isFeatureActive(featureFlipping, FEATURE_CAPTCHA))
        ) {
            // Objet envoyé au backend pour valider le captcha contenant l'id et le code du captcha
            const dataFormat = {
                declarationHonneur: !!dataForm.declarationHonneur,
                // todo : refactorer une fois l'accordéon remis en place
                cgu: true,
                uuidBrouillon,
                captcha: isFeatureActive(featureFlipping, FEATURE_CAPTCHA)
                    ? informationsCaptcha
                    : {},
            };

            setCaptchaRecharge(false);

            try {
                // Envoi des données à l'API pour validation du captcha
                const response = await postApi(
                    usagerClientReducer,
                    API_COMPTE_CREER_ETAPE_VALIDATION_URL,
                    dataFormat,
                    CONTEXT_CREER_COMPTE_ETAPE_VALIDATION,
                );

                // Vérifier si la réponse contient bien des données et si la validation du captcha a échoué
                if (response?.data?.success === false || response === undefined) {
                    setCaptchaRecharge(true);
                }
            } catch (exception) {
                setCaptchaRecharge(true);
            }
        }
    };

    const hasFormValid = () => {
        return (
            isValid &&
            watch('isCguLues') &&
            ((informationsCaptcha && informationsCaptcha.code) ||
                !isFeatureActive(featureFlipping, FEATURE_CAPTCHA))
        );
    };

    const ouvrirModaleCgu = () => {
        setModaleCguOuverte(true);
    };

    const fermerModaleCgu = () => {
        setModaleCguOuverte(false);
    };

    const onRetourEtape = () => {
        retourEtape({ ...getValues() });
    };

    return (
        <SegmentLoader isLoading={isLoading}>
            {erreur && message && (
                <Row>
                    <Col col={12}>
                        <p className="fr-error">{message}</p>
                    </Col>
                </Row>
            )}
            <form onSubmit={handleSubmit(onSubmit)}>
                <Row>
                    <Col col={12}>
                        <InfoChampsObligatoire />
                    </Col>
                </Row>
                {isFeatureActive(featureFlipping, FEATURE_CAPTCHA) && (
                    <Row className="margin-right-sm">
                        <Col col={12}>
                            {isFeatureActive(featureFlipping, FEATURE_CAPTCH_ETAT) ? (
                                <CaptchaEtat
                                    informationsCaptcha={informationsCaptcha}
                                    setInfoCaptchaEtat={setInfoCaptchaEtat}
                                    captchaRecharge={captchaRecharge}
                                    setCaptchaRecharge={setCaptchaRecharge}
                                />
                            ) : (
                                <Captcha setInfoCaptcha={setInfosCaptcha} />
                            )}
                        </Col>
                    </Row>
                )}
                <Row className="margin-right-sm">
                    <Col col={12}>
                        <div style={{ display: 'flex' }}>
                            <CheckboxControl
                                id="declarationHonneur"
                                name="declarationHonneur"
                                value="declarationHonneur"
                                label="Je déclare que les informations fournies sont exactes et que toutes fausses informations sont de nature à engager la responsabilité du signataire *"
                                required
                                {...register('declarationHonneur', {
                                    required: "La déclaration sur l'honneur est obligatoire",
                                })}
                                state={formState.errors?.declarationHonneur ? 'error' : null}
                                messages={[formState.errors?.declarationHonneur?.message]}
                            />
                        </div>
                    </Col>
                </Row>
                <Row className="margin-top-md">
                    <Col col={12}>
                        <div>
                            <Button
                                type="button"
                                style={{
                                    textDecoration: 'underline',
                                    paddingLeft: 0,
                                    paddingRight: 0,
                                    marginBottom: 10,
                                    'font-size': '0.9rem',
                                }}
                                variant="tertiary-no-outline"
                                onClick={ouvrirModaleCgu}
                            >
                                Consulter les conditions générales d'utilisation
                            </Button>
                            <CheckboxControl
                                id="isCguLues"
                                name="isCguLues"
                                data-fr-opened="false"
                                label="J'accepte les conditions générales d'utilisation *"
                                required
                                {...register('isCguLues', {
                                    required:
                                        "L'acceptation des conditions générales d'utilisation est obligatoire",
                                })}
                                state={formState.errors?.isCguLues ? 'error' : null}
                                messages={[formState.errors?.isCguLues?.message]}
                            />
                        </div>
                    </Col>
                </Row>
                <ModaleCgu fermerModale={fermerModaleCgu} modaleOuverte={modaleCguOuverte} />
                <Row className="margin-top-lg">
                    <Col col={12}>
                        <ButtonGroup align="right" inline>
                            <Button
                                name="etapePrecedente"
                                variant="secondary"
                                isLoading={isLoading}
                                onClick={onRetourEtape}
                                type="button"
                            >
                                Retour
                            </Button>
                            <Button
                                name="valider"
                                variant="primary"
                                type="submit"
                                isLoading={isLoading}
                                disabled={!hasFormValid()}
                            >
                                Valider
                            </Button>
                        </ButtonGroup>
                    </Col>
                </Row>
            </form>
        </SegmentLoader>
    );
};

CreerCompteEtapeValidation.propTypes = {
    postApi: PropTypes.func.isRequired,
    erreur: PropTypes.bool,
    message: PropTypes.string,
    isLoading: PropTypes.bool,
    data: PropTypes.shape({
        uuidBrouillon: PropTypes.string.isRequired,
    }).isRequired,
    uuidBrouillon: PropTypes.string,
    setEtapeValidation: PropTypes.func.isRequired,
    retourEtape: PropTypes.func.isRequired,
    dataValidationRenseignee: PropTypes.shape({
        declarationHonneur: PropTypes.string,
        isCguLues: PropTypes.string,
    }),
    featureFlipping: PropTypes.object.isRequired,
};

export default connect(
    (state) => {
        const { isLoading, erreur, data, message } = state.compte.creer.validation;
        const { data: featureFlipping } = state.featureFlipping;
        return {
            isLoading,
            erreur,
            data,
            message,
            featureFlipping,
        };
    },
    {
        postApi: postAPI,
    },
)(CreerCompteEtapeValidation);
